<div class="contract-overview wrapper--spacing-horizontal">
  <h1 class="text--h1">{{ 'contract.contract-overview.title' | translate }}</h1>

  <div class="spacing--margin-bottom">
    @if (filterConfig) {
      <agr-filter [config]="filterConfig" [formControl]="filterControl"> </agr-filter>
    }
  </div>
  @if (tableConfig) {
    <agr-table [config]="tableConfig"></agr-table>
  }
</div>

<ng-template #statusColumn let-row="row">
  @if (row.contractStatus === contractStatusOptions.active) {
    <span>
      {{ 'contract.contract-overview.status-active' | translate }}
    </span>
  }
  @if (row.contractStatus === contractStatusOptions.inactive) {
    <span>
      {{ 'contract.contract-overview.status-inactive' | translate }}
    </span>
  }
  @if (row.contractStatus === contractStatusOptions.ended) {
    <span>
      {{ 'contract.contract-overview.status-ended' | translate }}
    </span>
  }
  @if (row.contractStatus === contractStatusOptions.unknown) {
    <span>
      {{ 'contract.contract-overview.status-unknown' | translate }}
    </span>
  }
</ng-template>

<ng-template #externalIdColumn let-row="row">
  <span>{{ row.externalId | trimZeroes }}</span>
</ng-template>

<ng-template #contractQuantityColumn let-row="row">
  <span>{{ row.contractQuantity | agrNumber }} </span>
</ng-template>

<ng-template #consumedQuantityColumn let-row="row">
  <span>{{ row.consumedQuantity | agrNumber: '1.0-0' }} </span>
</ng-template>

<ng-template #openQuantityColumn let-row="row">
  <span>{{ row.openQuantity | agrNumber: '1.0-0' }} </span>
</ng-template>

<ng-template #unitColumn let-row="row">
  <span>{{ row.unit | translate }} </span>
</ng-template>
